<template>
    <div class="form-group field field-checkboxlist">
        <p v-bind:id="contextId" class="control-label mb-3">{{ question.question }} <span v-if="question.required" class="text-muted small" style="font-weight: normal">Required</span></p>
        <div class="checkboxList">
            <div class="checkbox">
                <label v-bind:for="componnentId">
                <input v-bind:id="componnentId"
                       v-bind:type="'checkbox'" 
                       v-bind:name="componnentId" 
                       v-bind:required="question.required" 
                       v-bind:aria-describedby="contextId"
                       v-bind:aria-invalid="question.error ? 'true' : null"
                       v-bind:value="question.options"> 
                       <span>&nbsp;{{ question.options }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FormCheckboxList',
        props: {
            question: Object,
        },
        computed: {
            componnentId() {
                return 'Question' + this.$props.question.msqID;
            },
            contextId() {
                return this.componnentId + '-context';
            }
        }  
    }
</script>
